import Joi from 'joi';
import type { RequestFieldKey } from './showKeyboardAction';
import { requestFieldKeySchema } from './showKeyboardAction';
import { objectSchemaOf } from '../helpers';

export interface ISubmitKeyboardParams {
  conversationId: string;
  inputValue: string;
  inputKey: RequestFieldKey;
}

export const submitKeyboardParamsSchema = objectSchemaOf<ISubmitKeyboardParams>(
  {
    conversationId: Joi.string().required(),
    inputValue: Joi.string().required(),
    inputKey: requestFieldKeySchema.required(),
  }
);
